export default class CanvasEyedropper {
  constructor(elCanvas, colorManager, eyedropperPopup) {
    this._elCanvas = elCanvas;
    this._colorManager = colorManager;
    this._eyedropperPopup = eyedropperPopup;
    this._ctx = this._elCanvas.getContext('2d', {
      willReadFrequently: true,
    });
  }
  start(cursorX, cursorY) {
    const rect = this._elCanvas.getBoundingClientRect();
    const ratioX = this._elCanvas.width / rect.width;
    const ratioY = this._elCanvas.height / rect.height;
    const x = Math.floor((cursorX - rect.x) * ratioX);
    const y = Math.floor((cursorY - rect.y) * ratioY);
    const { data } = this._ctx.getImageData(x, y, 1, 1);
    this._lastPickedPixel = this._colorManager.normalize(data);
    this._eyedropperPopup.popup(this._lastPickedPixel, cursorX, cursorY);
  }
  cancel() {
    this._eyedropperPopup.hide();
  }
  drag(cursorX, cursorY) {
    const rect = this._elCanvas.getBoundingClientRect();
    const ratioX = this._elCanvas.width / rect.width;
    const ratioY = this._elCanvas.height / rect.height;
    const x = Math.floor((cursorX - rect.x) * ratioX);
    const y = Math.floor((cursorY - rect.y) * ratioY);
    const { data } = this._ctx.getImageData(x, y, 1, 1);
    const next = this._colorManager.normalize(data);
    if(0 <= x && x < this._elCanvas.width && 0 <= y && y < this._elCanvas.height) {
      if(next.some((v, i) => v !== this._lastPickedPixel[i])) {
        this._lastPickedPixel = next;
        this._eyedropperPopup.popup(next, cursorX, cursorY);
      } else {
        this._eyedropperPopup.move(cursorX, cursorY);
      }
    }
  }
  finish() {
    this._colorManager.set(this._lastPickedPixel);
    this._eyedropperPopup.hide();
  }
}
